/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Directive, ElementRef, Input, OnDestroy, inject } from '@angular/core'
import { PidxGoogleTagManagerIntegrationService } from './pidx-google-tag-manager-integration.service'

@Directive({
  selector: '[myprofileUiValidationTrack]',
  standalone: false,
})
export class PidxFormValidationTrackingDirective implements OnDestroy {
  private elementRef = inject(ElementRef)
  private googleTagManagerIntegrationService = inject(PidxGoogleTagManagerIntegrationService)

  @Input('myprofileUiValidationTrack') formName!: string
  private inputFields: Element[] = []
  private readonly boundGoogleEventListener = this.googleEventListener.bind(this)

  constructor() {
    this.addListener()
  }

  public addListener() {
    this.clearListener()

    setTimeout(() => {
      this.googleTagManagerIntegrationService.setupValidationError(this.formName)
      this.inputFields = Array.from(this.elementRef.nativeElement.querySelectorAll('input'))
      const selectFields: Element[] = Array.from(this.elementRef.nativeElement.querySelectorAll('select'))
      selectFields.forEach((element) => {
        this.inputFields = [...this.inputFields, element]
      })

      this.inputFields.forEach((element) => {
        element.addEventListener('blur', this.boundGoogleEventListener)
      })
    })
  }

  public clearListener() {
    this.googleTagManagerIntegrationService.clearValidationErrors(this.formName)
    this.inputFields?.forEach((element) => {
      element.removeEventListener('blur', this.boundGoogleEventListener)
    })
  }

  public googleEventListener($event: Event) {
    setTimeout(() => {
      const target = $event.target as HTMLElement
      const closestFormControlName = target.closest('[formcontrolname]')
      const formControlName = closestFormControlName ? closestFormControlName.getAttribute('formcontrolname') : target.getAttribute('name')

      if (target.classList.contains('ng-invalid')) {
        this.googleTagManagerIntegrationService.addValidationError(this.formName, formControlName ?? '')
      } else {
        this.googleTagManagerIntegrationService.removeValidationError(this.formName, formControlName ?? '')
      }
    })
  }

  public ngOnDestroy() {
    this.clearListener()
  }
}
